"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiffApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class LiffApi extends runtime.BaseAPI {
    /**
     * LINE 會員綁定（透過手機號碼比對後台會員）
     */
    apiLiffBindMemberPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/BindMember`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffBindMemberModelToJSON)(requestParameters['liffBindMemberModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * LINE 會員綁定（透過手機號碼比對後台會員）
     */
    apiLiffBindMemberPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffBindMemberPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 檢查 LINE ID 是否為合作店家（用於 LIFF 判斷顯示不同畫面）
     */
    apiLiffCheckPartnerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['lineId'] != null) {
                queryParameters['lineId'] = requestParameters['lineId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/CheckPartner`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 檢查 LINE ID 是否為合作店家（用於 LIFF 判斷顯示不同畫面）
     */
    apiLiffCheckPartnerGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffCheckPartnerGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 刪除合作店家自訂價格
     */
    apiLiffDeletePartnerPriceDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orgId'] != null) {
                queryParameters['orgId'] = requestParameters['orgId'];
            }
            if (requestParameters['frameNo'] != null) {
                queryParameters['frameNo'] = requestParameters['frameNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/DeletePartnerPrice`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 刪除合作店家自訂價格
     */
    apiLiffDeletePartnerPriceDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffDeletePartnerPriceDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得所有上架中的相框列表（LIFF 用）
     */
    apiLiffGetActiveFramesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/GetActiveFrames`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得所有上架中的相框列表（LIFF 用）
     */
    apiLiffGetActiveFramesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLiffGetActiveFramesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢 LINE 會員綁定狀態
     */
    apiLiffGetBindingStatusGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['lineId'] != null) {
                queryParameters['lineId'] = requestParameters['lineId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/GetBindingStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢 LINE 會員綁定狀態
     */
    apiLiffGetBindingStatusGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffGetBindingStatusGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得相框商品列表（含價格）
     */
    apiLiffGetFrameProductsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/GetFrameProducts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得相框商品列表（含價格）
     */
    apiLiffGetFrameProductsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLiffGetFrameProductsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得有效優惠套組
     */
    apiLiffGetPromotionsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/GetPromotions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得有效優惠套組
     */
    apiLiffGetPromotionsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLiffGetPromotionsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 合作店家記錄列印 / 複印動作
     */
    apiLiffLogActionPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/LogAction`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffLogActionModelToJSON)(requestParameters['liffLogActionModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 合作店家記錄列印 / 複印動作
     */
    apiLiffLogActionPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffLogActionPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 列印 QRCode：加密 LineID+時間戳，寫入使用紀錄，回傳 QRCode 字串（支援多相框）
     */
    apiLiffOrderQRCodePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/OrderQRCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffPrintQrModelToJSON)(requestParameters['liffPrintQrModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 列印 QRCode：加密 LineID+時間戳，寫入使用紀錄，回傳 QRCode 字串（支援多相框）
     */
    apiLiffOrderQRCodePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffOrderQRCodePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 合作店家刪除自己上傳的相框
     */
    apiLiffPartnerDeleteFrameDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['frameNo'] != null) {
                queryParameters['frameNo'] = requestParameters['frameNo'];
            }
            if (requestParameters['orgId'] != null) {
                queryParameters['orgId'] = requestParameters['orgId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/PartnerDeleteFrame`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 合作店家刪除自己上傳的相框
     */
    apiLiffPartnerDeleteFrameDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffPartnerDeleteFrameDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 合作店家相框列表（回傳所有相框，標記哪些是本店家上傳的，含狀態與排程）
     */
    apiLiffPartnerListFramesGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orgId'] != null) {
                queryParameters['orgId'] = requestParameters['orgId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/PartnerListFrames`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 合作店家相框列表（回傳所有相框，標記哪些是本店家上傳的，含狀態與排程）
     */
    apiLiffPartnerListFramesGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffPartnerListFramesGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 合作店家更新相框狀態 / 上下架時間
     */
    apiLiffPartnerUpdateFramePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/PartnerUpdateFrame`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffUpdateFrameModelToJSON)(requestParameters['liffUpdateFrameModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 合作店家更新相框狀態 / 上下架時間
     */
    apiLiffPartnerUpdateFramePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffPartnerUpdateFramePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 合作店家上傳相框（multipart/form-data: orgId, frameName, file）
     */
    apiLiffPartnerUploadFramePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['orgId'] != null) {
                formParams.append('orgId', requestParameters['orgId']);
            }
            if (requestParameters['frameName'] != null) {
                formParams.append('frameName', requestParameters['frameName']);
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            const response = yield this.request({
                path: `/api/Liff/PartnerUploadFrame`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 合作店家上傳相框（multipart/form-data: orgId, frameName, file）
     */
    apiLiffPartnerUploadFramePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffPartnerUploadFramePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 掃描 QRCode：解密，還原對應的合成圖片 JSON，寫入使用紀錄
     */
    apiLiffScanQRCodePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/ScanQRCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffScanQrModelToJSON)(requestParameters['liffScanQrModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 掃描 QRCode：解密，還原對應的合成圖片 JSON，寫入使用紀錄
     */
    apiLiffScanQRCodePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffScanQRCodePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 設定合作店家自訂價格（upsert：新增或更新）
     */
    apiLiffSetPartnerPricePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/SetPartnerPrice`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffSetPriceModelToJSON)(requestParameters['liffSetPriceModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 設定合作店家自訂價格（upsert：新增或更新）
     */
    apiLiffSetPartnerPricePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffSetPartnerPricePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 解除 LINE 會員綁定
     */
    apiLiffUnbindMemberPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/Liff/UnbindMember`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.LiffUnbindModelToJSON)(requestParameters['liffUnbindModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 解除 LINE 會員綁定
     */
    apiLiffUnbindMemberPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.apiLiffUnbindMemberPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.LiffApi = LiffApi;
